import { useRouter } from "next/router";
import React, { useEffect } from "react";
import { useUserContext } from "../../User/Auth/UserContext";

export function AuthRedirect() {
  return <Redirect to="/login/signIn"></Redirect>;
}
export default function Redirect(props: { to: string; is_return?: boolean }) {
  const router = useRouter();
  const userCtx = useUserContext();

  useEffect(() => {
    console.warn("Before redirect", router);
    console.log("Go To Another Page" + props.to);
    userCtx.setAuthRequiredPath(router.asPath);
    // router.push(props.to);
    if (props.is_return)
      router.replace({
        pathname: props.to,
        query: { returnUrl: router.asPath },
      });
    else router.replace(props.to);
  }, []);
  return <div />;
}
